import { gql, useQuery } from "@apollo/client";
import { Box } from "@mui/material";
import { ErrorView } from "src/components/ErrorView";
import { LoadingSpinner } from "src/components/LoadingSpinner";
import {
  CostToMoveAnalysisQuery,
  CostToMoveAnalysisQueryVariables,
} from "src/__generated__/graphql";
import { CostToMove } from "./CostToMove";

type Props = {
  filter: { [key: string]: number[] | null | undefined };
  targetBandPoint: string;
};
export function CostToMoveLoadingBoundary({
  filter,
  targetBandPoint,
}: Props): JSX.Element | null {
  const { data, error } = useQuery<
    CostToMoveAnalysisQuery,
    CostToMoveAnalysisQueryVariables
  >(CostToMoveLoadingBoundary.query, {
    variables: { filter, targetBandPoint },
  });

  if (!data) {
    if (error) {
      return <ErrorView text={error.message} />;
    }
    return (
      <Box pt={16}>
        <LoadingSpinner />
      </Box>
    );
  }

  return (
    <CostToMove
      data={data.costToMoveAnalysis}
      filter={filter}
      targetBandPoint={targetBandPoint}
    />
  );
}

CostToMoveLoadingBoundary.query = gql`
  ${CostToMove.fragments.costToMoveAnalysis}
  query CostToMoveAnalysisQuery(
    $targetBandPoint: String!
    $filter: GetEmployeesInput
  ) {
    costToMoveAnalysis(target: $targetBandPoint, filter: $filter) {
      ...CostToMove_costToMoveAnalysis
    }
  }
`;
